import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string, name: string, masterId: number) =>
  axios.delete(
    `${process.env.REACT_APP_API_HOST}/admin/masters/upload/diplomas?id=${masterId}&name=${name}`,
    config(token)
  );
